/**
 * Shared card and message components for dashboard tabs.
 */
import React from 'react';
import { FaCheck, FaExclamation } from 'react-icons/fa';

/** Success / status banner (profile updates, booking toasts) */
export const SuccessBanner = ({ children, variant = 'success', className = '' }) => {
  const isWarn = variant === 'warn';
  return (
    <div
      className={`dashboard-success-banner ${isWarn ? 'dashboard-success-banner--warn' : ''} ${className}`.trim()}
      role="alert"
      aria-live="polite"
    >
      <span className="dashboard-success-banner__check" aria-hidden="true">
        {isWarn ? <FaExclamation /> : <FaCheck />}
      </span>
      <p className="dashboard-success-banner__text">{children}</p>
    </div>
  );
};

export const Card = ({
  title,
  children,
  busy = false,
  error = '',
  extraClass = '',
  headerRight = null,
}) => (
  <section className={`card fade-in ${extraClass}`.trim()}>
    {headerRight ? (
      <div className="card-head">
        <h2 className="card-title">{title}</h2>
        <div className="card-head-right">{headerRight}</div>
      </div>
    ) : (
      <h2 className="card-title">{title}</h2>
    )}
    {busy ? (
      <CardSkeletonLines />
    ) : error ? (
      <Error>{error}</Error>
    ) : (
      children
    )}
  </section>
);

export const CardSkeletonLines = () => (
  <>
    <div className="skeleton line" style={{ width: '70%' }} />
    <div className="skeleton line" style={{ width: '90%' }} />
    <div className="skeleton line" style={{ width: '65%' }} />
  </>
);

export const CardSkeleton = ({ label }) => <Card title={label} busy />;

/** Full-content-area loading buffer for any tab (spinner only, no loading text). */
export const TabLoadingBuffer = ({ label = 'Loading' }) => (
  <div
    className="tab-loading-buffer"
    role="status"
    aria-live="polite"
    aria-busy="true"
    aria-label={label}
  >
    <div className="tab-loading-buffer__spinner" aria-hidden="true" />
  </div>
);

export const Error = ({ children }) => <p className="error-msg">{children}</p>;
export const Success = ({ children }) => (
  <p className="success-msg">{children}</p>
);
export const Chip = ({ status, children }) => (
  <span className={`chip ${status}`}>{children}</span>
);
